import React from 'react'

export const RecommendedFundsSkeleton: React.FC = () => (
  <div className='card p-8 placeholder-glow'>
    <span className='placeholder rounded mb-8 d-block' style={{ height: 26, width: 110 }} />

    <div className='d-flex gap-3 mb-8'>
      <span className='placeholder rounded' style={{ height: 36, width: 140 }} />
      <span className='placeholder rounded' style={{ height: 36, width: 140 }} />
      <span className='placeholder rounded' style={{ height: 36, width: 140 }} />
    </div>

    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', padding: '8px 16px', marginBottom: 4 }}>
      <span className='placeholder rounded' style={{ height: 14, width: 60 }} />
      <span className='placeholder rounded' style={{ height: 14, width: 130 }} />
    </div>

    {Array.from({ length: 5 }).map((_, i) => (
      <div key={i}>
        {i > 0 && <hr style={{ margin: 0, borderColor: '#F3F4F6' }} />}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', alignItems: 'center', padding: '16px' }}>
          <span className='placeholder rounded' style={{ height: 18, width: `${100 + i * 20}px` }} />
          <span className='placeholder rounded' style={{ height: 36 }} />
        </div>
      </div>
    ))}
  </div>
)
